import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Ng4FilesService, Ng4FilesConfig, Ng4FilesStatus, Ng4FilesSelected
} from './ng4-files';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { ApiService } from '../Services/api.service';
import { environment } from '../../../environments/environment';
import { DialogsService } from '../Services';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'cmat-picture',
  templateUrl: './t_picture.component.html',
  styleUrls: ['./picture.component.css']
})
export class PictureComponent implements OnInit {

  @Input() uploadable: boolean = true;
  @Input() zoomed: boolean = false;
  @Input() resizeOnClick: boolean = true;

  fullsize: boolean = false;


  @Input() src = undefined;
  @Input() path = undefined;
  @Input() filename = undefined;
  @Input() freeAfterChange = false;

  @Input()
    alt: string;
  
  @Output()
  changeTriggered: EventEmitter<string> = new EventEmitter();


  public selectedFile;
  public uploadedImage: File;

  public showSpinner = false;

  private uploadError: Array<string> = [
    "OK",
    "1 seul fichier SVP",
    "Taille maximum : 6Mo",
    "Taille maximum : 6Mo",
    "Image jpg, jpeg ou png uniquement"
  ];

  private uniqID:string = '';


  configImage: Ng4FilesConfig = {
    acceptExtensions: ['jpg', 'jpeg', 'png'],
    maxFilesCount: 1,
    maxFileSize: 6e6,
    totalFilesSize: 6e6   //(~6Mo)
  };
  
  constructor(
    private sanitizer:DomSanitizer,
    private ng4FilesService: Ng4FilesService,
    private ng2ImgMax: Ng2ImgMaxService,
    private apiService: ApiService,
    private dialog:DialogsService,
    private translate:TranslocoService
  ){}

  ngOnInit() {
    let rand = Math.round(Math.random()*10000);
    this.uniqID = 'picid'+rand;

    this.ng4FilesService.addConfig(this.configImage, 'my-image-config');


    if(this.src!=undefined && this.src!=''
    && this.src.slice(0,10) != 'data:image') 
      this.loadPic(this.src);

    if(this.path!=undefined && this.filename) this.savePic(this.path, this.filename);
  }

  autosize($event)
  {
    if(!this.zoomed) return;

    let img:HTMLElement = window.document.getElementById(this.uniqID);
    let pic:HTMLElement = img.parentElement;
    
    if(img.clientWidth >= img.clientHeight) {
      img.style.height = pic.clientHeight+'px';
      img.style.width = 'auto';  // (img.clientWidth*pic.clientHeight/pic.clientWidth) + 'px';
    } else {
      img.style.width = pic.clientWidth+'px';
      img.style.height = 'auto';  // (img.clientWidth*pic.clientHeight/pic.clientWidth) + 'px';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }


  public filesSelect(selectedFile: Ng4FilesSelected): void {
    if (selectedFile.status !== Ng4FilesStatus.STATUS_SUCCESS) {
      alert(this.uploadError[selectedFile.status])
      return;
    }

    this.selectedFile = selectedFile.files[0];
    
    this.showSpinner = true;
    this.ng2ImgMax.resizeImage(this.selectedFile, 1000, 1000).subscribe(
      result => {
        this.uploadedImage = result;
        this.getImagePreview(this.uploadedImage);
      },
      error => {
        console.log('😢 Oh no!', error); 
      }
    );
  }

  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.src = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
      
      if(this.path!=undefined && this.filename) this.savePic(this.path, this.filename);
      else {
        this.changeTriggered.emit(this.src.changingThisBreaksApplicationSecurity);
        if(this.freeAfterChange) this.src = '';
        this.showSpinner = false;
      }
    };
  }

  public delete()
  {
    let message = this.translate.translate('Delete picture ?')
    this.dialog.confirm(message)
    .subscribe(confirm=>{
      if(confirm) {
        this.src = '';
        this.changeTriggered.emit('');
      }
    }) 
    
  }

  resize()
  {
    if(!this.uploadable) this.fullsize = !this.fullsize;
  }


  savePic(path, filename)
  {
    let stringSrc:string = typeof this.src == 'string' ? this.src : this.src.changingThisBreaksApplicationSecurity;

    if(stringSrc.slice(0,10) != 'data:image') return; //already a file
    this.apiService.SaveToServer('image', {
      'Image': stringSrc,
      'path': path,
      'filename': filename
    }).then(s => s.subscribe((response:any) => {
      this.changeTriggered.emit(response.encodedFilePath);
      this.loadPic(response.encodedFilePath);
    }) );
  }

  loadPic(encodedFilePath)
  {
    this.apiService.testConnexion();
    if(!this.apiService.hasConnexion) return; //conserver base64 si hors connexion

    let newsrc = environment.apiBaseUrl+'/image/'+encodedFilePath
                +'?token='+localStorage.getItem('access_token');  //connexion token
    this.src = newsrc;
    if(this.freeAfterChange) this.src = '';
    this.showSpinner = false;
  }
}